import { useFormSharingQuery } from '../../lib/Queries';
import EmbedPopupIcon from '../icons/EmbedPopupIcon.jsx';
import IconSelectButton from '../IconSelectButton.jsx';
import { useEffect, useState } from 'react';
import Select from '../Select';

const optionNames = {
    default: 'Default',
    eventTypes: 'Event Type',
    bookableResources: 'Person',
    instances: 'Class/Workshop',
};

const ShareOptions = ({ form, setShareUrl, shareUrl }) => {
    const [option, setOption] = useState('default');
    const { data, isLoading } = useFormSharingQuery(form?.id);

    useEffect(() => {
        if (data?.baseUrl) setShareUrl(data?.baseUrl);
    }, [option]);

    if (
        !data ||
        ((!data?.eventTypes?.length || data?.eventTypes?.length <= 1) &&
            !data?.instances?.length &&
            !data?.bookableResources?.length)
    ) {
        return null;
    }

    const rawOptions = data[option] || [];
    const dropdownOptions = [{ value: data?.baseUrl, label: 'Choose...' }];
    //rawOptions.forEach(opt => (dropdownOptions[opt.url] = opt.label));
    rawOptions.forEach(opt =>
        dropdownOptions.push({ value: opt.url, label: opt.label }),
    );

    const OptSelect = ({ thisOption, description }) => {
        const div = (
            <>
                <div
                    className={`text-base ${option === thisOption ? 'text-black' : 'text-gray-550'} font-medium`}
                >
                    {optionNames[thisOption]}
                </div>
            </>
        );
        return (
            <IconSelectButton
                icon={div}
                label={description}
                isSelected={option === thisOption}
                onClick={() => setOption(thisOption)}
                className="w-48 h-24 bg-white"
            />
        );
    };

    return (
        <div className="mb-6">
            <div className="flex items-center gap-x-4">
                <OptSelect
                    thisOption="default"
                    description="Link to form without anything pre-filled"
                />

                {data?.eventTypes?.length > 1 && (
                    <OptSelect
                        thisOption="eventTypes"
                        description="Link to a specific event type"
                    />
                )}

                {data?.bookableResources?.length > 1 && (
                    <OptSelect
                        thisOption="bookableResources"
                        description="Link to a specific person/thing"
                    />
                )}

                {!!data?.instances?.length && (
                    <OptSelect
                        thisOption="instances"
                        description="Link to a specific class/workshop time"
                    />
                )}
            </div>

            {Object.keys(dropdownOptions)?.length > 1 && (
                <div className="pt-6 border-b pb-6">
                    <Select
                        label={`Select ${optionNames[option]}`}
                        options={dropdownOptions}
                        onChange={value => {
                            setShareUrl(value);
                        }}
                        value={shareUrl}
                    />
                </div>
            )}
        </div>
    );
};

export default ShareOptions;
